import { render, staticRenderFns } from "./TabModal.vue?vue&type=template&id=cec12b44&scoped=true&"
import script from "./TabModal.vue?vue&type=script&lang=js&"
export * from "./TabModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec12b44",
  null
  
)

export default component.exports